import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bg-white rounded-lg border border-gray-200 shadow-sm p-3 mb-4 last:mb-0"
}
const _hoisted_2 = { class: "grid grid-cols-2 md:flex md:flex-row gap-2" }

import { computed } from 'vue'
import { ActionButton } from '@/components'
import ProductCouleurLieeDelier from './ProductCouleurLieeDelier.vue'
import type { ProduitCatalogue } from '@/types'

interface Props {
  products: ProduitCatalogue[]
  selectedIds: number[]
  activeTab?: 'en_ligne' | 'brouillon' | 'supprime'
}

interface Emits {
  (e: 'update:products', products: ProduitCatalogue[]): void
  (e: 'delete-selected'): void
  (e: 'make-visible-selected'): void
  (e: 'make-invisible-selected'): void
  (e: 'link-colors-selected'): void
  (e: 'delink-colors-selected'): void
  (e: 'publish-selected'): void
  (e: 'reactivate-selected'): void
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductBulkActions',
  props: {
    products: {},
    selectedIds: {},
    activeTab: {}
  },
  emits: ["update:products", "delete-selected", "make-visible-selected", "make-invisible-selected", "link-colors-selected", "delink-colors-selected", "publish-selected", "reactivate-selected"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

// Nombre sélectionné vient du parent
const selectedCount = computed(() => props.selectedIds.length)

// const handleSelectAll = () => {
//   if (selectedProducts.value.length === props.products.length) {
//     selectedProducts.value = []
//   } else {
//     selectedProducts.value = props.products.map(p => p.id)
//   }
// }

// const handleDelete = () => {
//   if (selectedProducts.value.length === 0) return
//
//   if (confirm(`Êtes-vous sûr de vouloir supprimer ${selectedProducts.value.length} produit(s) ?`)) {
//     // Supprimer les produits sélectionnés
//     const updatedProducts = props.products.filter(p => !selectedProducts.value.includes(p.id))
//     emit('update:products', updatedProducts)
//     selectedProducts.value = []
//   }
// }
//
// const handleMakeVisible = () => {
//   if (selectedProducts.value.length === 0) return
//
//   const updatedProducts = props.products.map(product => {
//     if (selectedProducts.value.includes(product.id)) {
//       return { ...product, visible: true }
//     }
//     return product
//   })
//   emit('update:products', updatedProducts)
// }

// const handleMakeInvisible = () => {
//   if (selectedProducts.value.length === 0) return
//
//   const updatedProducts = props.products.map(product => {
//     if (selectedProducts.value.includes(product.id)) {
//       return { ...product, visible: false }
//     }
//     return product
//   })
//   emit('update:products', updatedProducts)
// }
//
// const handleLinkColors = () => {
//   if (selectedProducts.value.length === 0) return
//   alert(`Liaison des couleurs pour ${selectedProducts.value.length} produit(s)`)
// }

const handleDelete = () => {
  if (!props.selectedIds.length) return
  emit('delete-selected')
}

const handleMakeVisible = () => {
  if (!props.selectedIds.length) return

  emit('make-visible-selected')
}

const handleMakeInvisible = () => {
  if (!props.selectedIds.length) return

  emit('make-invisible-selected')
}

const handleLinkColors = () => {
  if (!props.selectedIds.length) return
  emit('link-colors-selected')
}

const handleDelinkColors = () => {
  if (!props.selectedIds.length) return
  emit('delink-colors-selected')
}

const handlePublish = () => {
  if (!props.selectedIds.length) return
  emit('publish-selected')
}

const handleReactivate = () => {
  if (!props.selectedIds.length) return
  emit('reactivate-selected')
}

return (_ctx: any,_cache: any) => {
  return (selectedCount.value > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "text-xs font-semibold text-gray-800 mb-2" }, "Actions en lot", -1)),
        _createElementVNode("div", _hoisted_2, [
          (props.activeTab === 'supprime')
            ? (_openBlock(), _createBlock(_unref(ActionButton), {
                key: 0,
                label: "Réactiver",
                variant: "success",
                onClick: handleReactivate,
                disabled: selectedCount.value === 0,
                title: selectedCount.value === 0 ? 'Sélectionnez des produits pour activer cette action' : undefined,
                size: "sm",
                customClass: "!text-[10px] !px-1.5 !py-0.5 !min-h-0 !h-6 !w-auto min-[976px]:whitespace-nowrap w-full !mr-0"
              }, null, 8, ["disabled", "title"]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createVNode(_unref(ActionButton), {
                  label: "Rendre visible",
                  variant: "success",
                  onClick: handleMakeVisible,
                  disabled: selectedCount.value === 0,
                  title: selectedCount.value === 0 ? 'Sélectionnez des produits pour activer cette action' : undefined,
                  size: "sm",
                  customClass: "!text-[10px] !px-1.5 !py-0.5 !min-h-0 !h-6 !w-auto min-[976px]:whitespace-nowrap w-full !mr-0"
                }, null, 8, ["disabled", "title"]),
                _createVNode(_unref(ActionButton), {
                  label: "Rendre invisible",
                  variant: "warning",
                  onClick: handleMakeInvisible,
                  disabled: selectedCount.value === 0,
                  title: selectedCount.value === 0 ? 'Sélectionnez des produits pour activer cette action' : undefined,
                  size: "sm",
                  customClass: "!text-[10px] !px-1.5 !py-0.5 !min-h-0 !h-6 !w-auto min-[976px]:whitespace-nowrap w-full !mr-0"
                }, null, 8, ["disabled", "title"]),
                _createVNode(ProductCouleurLieeDelier, {
                  "selected-count": selectedCount.value,
                  onLinkColorsSelected: handleLinkColors,
                  onDelinkColorsSelected: handleDelinkColors
                }, null, 8, ["selected-count"]),
                (props.activeTab === 'brouillon')
                  ? (_openBlock(), _createBlock(_unref(ActionButton), {
                      key: 0,
                      label: "Mettre en ligne",
                      variant: "success",
                      onClick: handlePublish,
                      disabled: selectedCount.value === 0,
                      title: selectedCount.value === 0 ? 'Sélectionnez des produits pour activer cette action' : undefined,
                      size: "sm",
                      customClass: "!text-[10px] !px-1.5 !py-0.5 !min-h-0 !h-6 !w-auto min-[976px]:whitespace-nowrap w-full !mr-0"
                    }, null, 8, ["disabled", "title"]))
                  : _createCommentVNode("", true),
                _createVNode(_unref(ActionButton), {
                  label: "Supprimer",
                  variant: "danger",
                  onClick: handleDelete,
                  disabled: selectedCount.value === 0,
                  title: selectedCount.value === 0 ? 'Sélectionnez des produits pour activer cette action' : undefined,
                  size: "sm",
                  customClass: "!text-[10px] !px-1.5 !py-0.5 !min-h-0 !h-6 !w-auto min-[976px]:whitespace-nowrap w-full !mr-0"
                }, null, 8, ["disabled", "title"])
              ], 64))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})